import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const updateAdminBom = createAsyncThunk(
    "/admin/update-bom",
    async ({ id, payload }) => {
        try {
            const myurl = `${V_URL}/believe/update-bom/${id}`;
            const response = await axios({
                method: "post",
                url: myurl,
                data: payload,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
                },
            });
            const data = response.data;
            if (data.success === true) {
                return data;
            } else {
                throw new Error(data.message || "Failed to update BOM");
            }
        } catch (error) {
            console.error("Error in updateAdminBom:", error);
            toast.error(error.response?.data?.message || "Failed to update BOM");
            throw error;
        }
    }
);

const updateAdminBomSlice = createSlice({
    name: "updateAdminBom",
    initialState: {
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(updateAdminBom.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateAdminBom.fulfilled, (state) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(updateAdminBom.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default updateAdminBomSlice.reducer;
